import React from 'react';
import PropTypes from 'prop-types';

/**
 * Component that displays nutritional information messages.
 *
 * @function
 * @param       {array} nutritional array of nutritional info from the API for this item.
 * @constructor
 */
function NutritionalInfo({ nutritional }) {
    //console.log('n', nutritional);
    return (
        <ul>
            {nutritional.map((item, idx) => {
                return <li key={`nutritional-${idx}`}>{item}</li>;
            })}
        </ul>
    );
}

NutritionalInfo.propTypes = {
    nutritional: PropTypes.array
};

export { NutritionalInfo };
